import React, { useEffect, useState } from "react";
import {
  Container,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { useMemo } from "react";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  Label,
  Input,
} from "reactstrap";
import classnames from "classnames";
import Select from "react-select";
import { FaCheckCircle } from "react-icons/fa";
import { MdError } from "react-icons/md";

// assets
import "../../common/styles/hosting.css";
// import FixedProjectHeader from "../Projects/FixedProjectHeader"
import Draggable, { DraggableCore } from "react-draggable";
import { Resizable, ResizableBox } from "react-resizable";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Dropzone from "react-dropzone";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Pagi2 from "common/utils/Pagi2";
import userImg from "../../assets/images/users/AdminImg.png";
import SampleImg from "../../assets/images/DemoImg.png";
import FixedProjectHeader from "common/utils/FixedProjectHeader";
import bugImg from "../../assets/images/bug.png";
import suggestionImg from "../../assets/images/suggestion1.png";
import {
  colourStyles,
  locationOptions,
  priority,
  projects,
  Type,
} from "common/utils/ComonOptions";
import "../../common/styles/support.css";
import axios from "axios";
import configure from "configure";
import moment from "moment";
import Loader from "components/Common/Loader";
import secureLocalStorage from "react-secure-storage";
import { notification } from "antd";
import Swal from "sweetalert2";
import Pagination from "common/utils/Pagination";

const ticketStatus = [
  { label: "Not Answered", value: "0" },
  { label: "Open", value: "1" },
  { label: "In Progress", value: "2" },
  { label: "Answered", value: "3" },
  { label: "on Hold", value: "4" },
  { label: "Closed", value: "5" },
];

function TableContainer({
  CurrentProject,
  fetchSupport,
  alldata,
  columns,
  data,
  formPopup,
  setFormPopup,
  Projects,
  setAccessDenied,
  setFilter,
  filter,
  supportType,
  setSupportType,
  selectToMove,
  setSelectToMove,
  setNoDrag,
  noDrag,
  Todays,
  setTodays,
  projects,
  setCurrentProject,
}) {
  const [fixedContent, setFixedContent] = useState(false);

  const navigate = useNavigate();

  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedFiles1, setselectedFiles1] = useState([]);
  const [Description, setdescription] = useState("");
  const [title, settitle] = useState("");
  const [Priority, setselectedPriority] = useState(null);
  const [type, settype] = useState(null);

  function handleAcceptedFiles1(files) {
    const updatedFiles = files.map((file) => ({
      ...file,
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    }));

    setselectedFiles1((prevFiles) => [...prevFiles, ...updatedFiles]);
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  document.addEventListener("scroll", () => {
    const scrollThreshold = window.innerHeight * 0.3;
    if (window.scrollY > scrollThreshold) {
      setFixedContent(true);
    } else {
      setFixedContent(false);
    }
  });

  const handleaddTicket = async (e) => {
    e.preventDefault();
    if (!selectedProject) {
      Swal.fire({
        icon: "warning",
        title: "Please select a project",
      });
      return;
    }
    if (!title.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Please enter a title",
      });
      return;
    }
    if (!Description.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Please enter a description",
      });
      return;
    }
    if (!Priority) {
      Swal.fire({
        icon: "warning",
        title: "Please select a priority",
      });
      return;
    }
    if (!type) {
      Swal.fire({
        icon: "warning",
        title: "Please select a type",
      });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("project_id", selectedProject.value);
      formData.append("subject", title);
      formData.append("description", Description);
      formData.append("priority", Priority.value || Priority); // depends on your select value
      formData.append("type", type.value || type); // same as above

      // Append files if any
      selectedFiles1.forEach((file, index) => {
        formData.append("support_file", file);
      });

      const token = secureLocalStorage.getItem("Token");

      const response = await axios.post(
        `${configure.apiUrl}/support`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pe-2">
                <FaCheckCircle size={20} color="green" />
              </div>
              <div>{`Ticket Created Successfull`}</div>
            </div>
          ),
        });
        // Reset form if needed
        fetchSupport();
        setAddTicket(false);
        setSelectedProject(null);
        setselectedFiles1([]);
        setdescription("");
        settitle("");
        setselectedPriority(null);
        settype(null);
      } else {
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pe-2">
                <MdError size={20} color="red" />
              </div>
              <div>{`Error`}</div>
            </div>
          ),
        });
      }
    } catch (error) {
      console.error("Error creating ticket:", error);
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pe-2">
              <MdError size={20} color="red" />
            </div>
            <div>{`Something Went Wrong`}</div>
          </div>
        ),
      });
    }
  };

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: "id", // Set the ID of the first column for default sorting
            desc: true, // `true` for descending, `false` for ascending
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;

  useEffect(() => setPageSize(50), []);

  const [addTicket, setAddTicket] = useState(false);
  // Handle Select All
  const handleSelectAll = () => {
    setSelectToMove(!selectToMove);
  };

  return (
    <div>
      <FixedProjectHeader
        setTodays={setTodays}
        Todays={Todays}
        columns={filter == "notAnswered" ? columns : "None"}
        type={"Support"}
        data={data}
        setAccessDenied={setAccessDenied}
        setFilter={setFilter}
        filter={filter}
        setFormPopup={setFormPopup}
        formPopup={formPopup}
        setSelectToMove={setSelectToMove}
        selectToMove={selectToMove}
        setNoDrag={setNoDrag}
        noDrag={noDrag}
        cancelBtn2={true}
        supportBtn={true}
        notAnsweredTickets={
          alldata.filter((item) => item.status === "0").length === 0
            ? 0
            : alldata.filter((item) => item.status === "0").length
        }
        openTickets={alldata.filter((item) => item.status === "1").length}
        inProgressTickets={alldata.filter((item) => item.status === "2").length}
        answeredTickets={alldata.filter((item) => item.status === "3").length}
        onHoldTickets={alldata.filter((item) => item.status === "4").length}
        closedTickets={alldata.filter((item) => item.status === "5").length}
        setSupportType={setSupportType}
        supportType={supportType}
        setAddTicket={setAddTicket}
        addTicket={addTicket}
        isSupport={true}
        projects={projects}
        setCurrentProject={setCurrentProject}
        CurrentProject={CurrentProject}
      />

      <div className="position-relative">
        <Table className="table table-bordered" {...getTableProps()}>
          <thead
            className={`${fixedContent && page.length >= 5
              ? "fix-fixed-support-header"
              : "fix-table-header"
              } `}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => {
                  const classNames = column.className;
                  return (
                    <th
                      key={index}
                      className={`col-t-${index + 1} ${classNames} ${index != 0 && "customShortIcon"
                        }`}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <div>
                        {/* <span style={{}}>{column.render("Header")}</span> */}
                        {column.render("Header")}
                        {column.isShortIcon ? (
                          <span
                            style={{
                              // position: index != 0 ? "absolute" : "",
                              // right: index != 0 ? "0" : "",
                              display: index == 0 ? "none" : "block",
                            }}
                            onClick={() =>
                              column.getSortByToggleProps().onClick()
                            }
                          >
                            <i
                              title="Ascending"
                              className={`bi bi-arrow-up ms-1 info-icon ${column.isSorted && !column.isSortedDesc
                                ? "text-dark"
                                : ""
                                }`}
                            ></i>
                            <i
                              title="Descending"
                              className={`bi bi-arrow-down info-icon ${column.isSorted && column.isSortedDesc
                                ? "text-dark"
                                : ""
                                }`}
                            ></i>
                          </span>
                        ) : null}

                        {column.isSelect ? (
                          <span
                            className="text-center"
                            // style={{
                            //   position: "absolute",
                            //   right: "1",
                            //   top : "10"
                            // }}
                            onClick={() => handleSelectAll()}
                          >
                            <input type="checkbox" />
                          </span>
                        ) : null}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>

          <tbody className="fix-support-table-body" {...getTableBodyProps()}>
            {page.length === 0 ? (
              <tr>
                <td
                  colSpan={columns.length}
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No data found
                </td>
              </tr>
            ) : (
              page.map((row, i) => {
                prepareRow(row);

                let backgroundStyle = {};
                const priority = row.original.priority_col;

                return (
                  <tr {...row.getRowProps()} key={i} style={backgroundStyle}>
                    {row.cells.map((cell, index) => (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${cell.column.className
                          } ${priority == "High" ? "highPriority" : ""}`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>

      {/* Add Ticket popup  */}
      <Modal isOpen={addTicket} size="xl" className="" centered>
        <div className="modal-header pe-4">
          <h5 className="modal-title mt-0">Add Ticket</h5>
          <button
            type="button"
            onClick={() => {
              setAddTicket(false);
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>

        <div className="modal-body pe-4">
          <Form className="row d-flex justify-content-center align-items-center">
            <div className="col-md-12 d-flex flex-column new-task-modal">
              <div className="col-md-12 d-flex gap-3 mb-4 justify-content-start align-items-end">
                <div className="col-sm-2">
                  <Label htmlFor="formrow-firstname-Input">Type</Label>
                  <Select
                    placeholder="Select Type"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    options={Type}
                    styles={colourStyles}
                    onChange={(selectedOption) => {
                      settype(selectedOption);
                    }}
                  />
                </div>
                <div className="col-sm-10 col-sm-8 pe-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Title <span className="text-danger">*</span>
                  </Label>
                  <div className="d-flex justify-content-start align-items-center gap-2">
                    <Input
                      type="text"
                      className="form-control"
                      placeholder="Enter Title"
                      onChange={(e) => settitle(e.target.value)}
                      onDoubleClick={() => setNoDrag(true)}
                      onMouseLeave={() => setNoDrag(false)}
                      onMouseEnter={() => setNoDrag(true)}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12 d-flex gap-3 mb-4 justify-content-start align-items-end">
                <div className="col-sm-2">
                  <Label htmlFor="formrow-firstname-Input">
                    Priority <span className="text-danger">*</span>
                  </Label>
                  <Select
                    placeholder="Select Priority"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    options={priority}
                    styles={colourStyles}
                    onChange={(selectedOption) => {
                      setselectedPriority(selectedOption);
                    }}
                  />
                </div>

                <div className="col-4">
                  <label htmlFor="formrow-firstname-Input">
                    Project <span className="text-danger">*</span>
                  </label>
                  <Select
                    placeholder="Select Project "
                    className="basic-multi-select"
                    classNamePrefix="select"
                    styles={colourStyles}
                    options={Projects}
                    value={selectedProject}
                    onChange={(selectedOption) => {
                      setSelectedProject(selectedOption);
                    }}
                  />
                </div>
              </div>

              <div className="col-md-12 d-flex mb-3 justify-content-start align-items-end flex-column gap-4">
                <div
                  className="col-12"
                  style={{ width: "100%", maxHeight: "400px" }}
                >
                  <label htmlFor="">Description</label>
                  <div
                    className="no-drag"
                    onDoubleClick={() => setNoDrag(true)}
                    onMouseLeave={() => setNoDrag(false)}
                    onMouseEnter={() => setNoDrag(true)}
                  >
                    <CKEditor
                      editor={ClassicEditor}
                      onReady={(editor) => { }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setdescription(data);
                      }}
                      config={{
                        height: "350px", // This makes CKEditor fill its container's height
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-12 d-flex">
                  <div className="col-md-6 d-flex gap-3 justify-content-start align-items-center">
                    <div className="col-md-4 mt-1">
                      <label htmlFor="">Attachment</label>
                      <Dropzone
                        onDrop={(acceptedFiles) => {
                          handleAcceptedFiles1(acceptedFiles);
                        }}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <div
                            className="dz-message needsclick p-0"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <div className="d-flex px-2 custom-file-upload align-items-center">
                              <div className="">
                                <i className="display-6 text-muted bx bxs-cloud-upload" />
                              </div>
                              <h5 className="mb-0 ms-2">Upload Files</h5>
                            </div>
                          </div>
                        )}
                      </Dropzone>
                    </div>
                    <div
                      className={`mt-1 dropzone-previews ${selectedFiles1.length > 0 ? "d-block" : "d-none"
                        }`}
                      id="file-previews"
                    >
                      <label className="mb-1">Uploaded Files</label>
                      <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                        <div className="p-0">
                          <Row className="align-items-center justify-content-evenly">
                            {selectedFiles1.map((f, i) => {
                              return (
                                <Col key={i} className="col-auto">
                                  <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt={f.name}
                                    src={f.preview}
                                  />
                                </Col>
                              );
                            })}
                          </Row>
                        </div>
                      </Card>
                    </div>
                  </div>
                  <div className="col-md-6 d-flex gap-3 justify-content-end align-items-end">
                    <div className="my-2 text-end">
                      <button
                        className=" btn btn-save btn-label"
                        onClick={handleaddTicket}
                      >
                        <i className="fas fa-save me-2 label-icon"></i>
                        Submit
                      </button>
                      <a
                        onClick={() => setAddTicket(false)}
                        className=" btn ms-md-2 btn-red btn-label"
                      >
                        <i className="dripicons-cross me-2 icon-center label-icon"></i>
                        CANCEL
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Modal>
    </div>
  );
}

const SupportPage = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1");
  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [filter, setFilter] = useState("notAnswered");
  const [viewTicketHistory, setViewTicketHistory] = useState(false);
  const [ticketLogs, setTicketLogs] = useState(false);

  const [formPopup, setFormPopup] = useState(false);
  const [editTitcket, setEditTicket] = useState(false);
  const [boxWidth, setBoxWidth] = useState(0);
  const [noDrag, setNoDrag] = useState(false);
  const [replyTicket, setReplyTicket] = useState(false);
  const [Data, setdata] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [defaultData, setdefaultData] = useState([]);
  const [Projects, setProjects] = useState([]);
  const [support_id, setsupport_id] = useState();
  const [Replys, setReplys] = useState([]);
  const [Answer, setAnswer] = useState("");
  const [selectedFiles1, setselectedFiles1] = useState([]);
  const [Todays, setTodays] = useState(false);
  const [TodaysData, setTodaysData] = useState([]);

  const onAddReply = async () => {
    const formdata = new FormData();
    formdata.append("support_id", support_id);
    formdata.append("reply", Answer);
    // selectedFiles1.forEach((file, index) => {
    // });
    formdata.append("reply_file", JSON.stringify(selectedFiles1));

    const Token = secureLocalStorage.getItem("Token");

    setLoading(true);
    try {
      const res = await axios.post(
        `${configure.apiUrl}/support/add/reply`,
        formdata,
        {
          headers: {
            Authorization: `Bearer ${Token}`,
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (res.data.success) {
        setLoading(false);
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pe-2">
                <FaCheckCircle size={20} color="green" />
              </div>
              <div>{`Reply Added Successfull`}</div>
            </div>
          ),
        });
        setReplyTicket(false);
        setselectedFiles1([]);
        setAnswer("");
      } else {
        setLoading(false);
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pe-2">
                <MdError size={20} color="red" />
              </div>
              <div>{`Error`}</div>
            </div>
          ),
        });
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pe-2">
              <MdError size={20} color="red" />
            </div>
            <div>{`Something Went Wrong`}</div>
          </div>
        ),
      });
    }
  };

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      if (modal_fullscreen) {
        setmodal_fullscreen(false);
      }
      if (replyTicket) {
        setReplyTicket(false);
      }
      if (viewTicketHistory) {
        setViewTicketHistory(false);
      }
      if (editTitcket) {
        setEditTicket(false);
      }
    }
  });

  //meta title
  document.title = "Support | Zithas Technologies";

  useEffect(() => {
    setSupportType("3");
  }, []);

  useEffect(() => {
    fetchSupport();
    fetchProjects();
  }, []);

  const fetchSupport = async () => {
    setLoading(true);
    const authUser = secureLocalStorage.getItem("Token");
    try {
      const res = await axios({
        method: "get",
        url: `${configure.apiUrl}/support`,
        // data: formData,
        headers: {
          Authorization: `Bearer ${authUser}`,
        },
      }).then((res) => {
        setdata(res.data.supportTickets);
        setTodaysData(res?.data?.todayRepliedTicket);
        setdefaultData(
          res?.data?.supportTickets?.filter((item) => item?.status === "0")
        );
        setLoading(false);
      });
    } catch (error) {
      console.log("Fetch Proposal Error", error);
      setLoading(false);
    }
  };
  const fetchProjects = async () => {
    setLoading(true);
    const authUser = secureLocalStorage.getItem("Token");
    try {
      const res = await axios({
        method: "get",
        url: `${configure.apiUrl}/projects`,
        // data: formData,
        headers: {
          Authorization: `Bearer ${authUser}`,
        },
      }).then((res) => {
        setProjects(
          res?.data?.projects?.map((item) => ({
            label: item.project_name,
            value: item.id,
          }))
        );
        setLoading(false);
      });
    } catch (error) {
      console.log("Fetch Proposal Error", error);
      setLoading(false);
    }
  };

  // popup upate width
  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth;
      setBoxWidth(viewportWidth * 0.72);
    };
    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  function handleAcceptedFiles1(files) {
    const updatedFiles = files.map((file) => ({
      ...file,
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    }));

    // Merge newly accepted files with existing selected files
    setselectedFiles1((prevFiles) => [...prevFiles, ...updatedFiles]);
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const [modal_Access, setAccessDenied] = useState(false);
  const navigate = useNavigate();
  const [supportType, setSupportType] = useState("1");

  const [selectToMove, setSelectToMove] = useState(false);

  const handleChange = () => {
    setSelectToMove(!selectToMove);
  };

  const onDelete = () => { };

  const fetchReply = async (id) => {
    setLoading(true);
    const token = secureLocalStorage.getItem("Token");
    try {
      const res = await axios
        .get(`${configure.apiUrl}/support/all/reply/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          // console.log("customer Dtaa", res.data.data)
          setReplys(res?.data?.replies?.reverse());
          setLoading(false);
        });
    } catch (error) {
      console.log("Customer - Profile", error);
      setLoading(false);
    }
  };

  const onstatusChange = async (id, status) => {
    setLoading(true);
    const Token = secureLocalStorage.getItem("Token");
    try {
      const res = await axios.put(
        `${configure.apiUrl}/support/${id}`,
        {
          status: status,
        },
        {
          headers: {
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      if (res.data.success) {
        setLoading(false);
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pe-2">
                <FaCheckCircle size={20} color="green" />
              </div>
              <div>{`Ticket Status Changed Successfull`}</div>
            </div>
          ),
        });
        fetchSupport();
      } else {
        setLoading(false);
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pe-2">
                <MdError size={20} color="red" />
              </div>
              <div>{`Error`}</div>
            </div>
          ),
        });
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pe-2">
              <MdError size={20} color="red" />
            </div>
            <div>{`Something Went Wrong`}</div>
          </div>
        ),
      });
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: false,
        className: "support_id",
      },

      {
        Header: "Type",
        accessor: "type",
        isInfoIcon: false,
        isShortIcon: false,
        className: "support_icon_type",
        Cell: (cellProps) => {
          const rowValue = cellProps.row.original.type;
          const rowIndex = cellProps.row.index;

          return (
            <div className="d-flex justify-content-center align-items-center gap-2 support_assign_box">
              {rowValue == "0" ? (
                <span>
                  <img
                    src={bugImg}
                    className="img-fluid bugImg"
                    title="Bug"
                  ></img>
                </span>
              ) : rowValue == "1" ? (
                <span>
                  <img
                    src={suggestionImg}
                    className="img-fluid"
                    title="Suggestion"
                  ></img>
                </span>
              ) : null}
              {rowIndex == 0 ? (
                <span>
                  <i title="High Priority" className="bx bxs-hot icon-hot"></i>
                </span>
              ) : rowIndex == 1 ? (
                <span>
                  <i
                    title="Medium Priority"
                    className="bx bxs-flame icon-flame"
                  ></i>{" "}
                </span>
              ) : rowIndex == 2 ? (
                <span>
                  <i title="Low priority" className="bx bxs-sun icon-sun"></i>
                </span>
              ) : rowIndex == 3 ? (
                <span>
                  <i title="High Priority" className="bx bxs-hot icon-hot"></i>
                </span>
              ) : rowIndex == 4 ? (
                <span>
                  <i
                    title="Medium Priority"
                    className="bx bxs-flame icon-flame"
                  ></i>
                </span>
              ) : null}
            </div>
          );
        },
      },

      {
        Header: "Project",
        accessor: "project_id",
        isInfoIcon: false,
        isShortIcon: false,
        className: "support_project",
        Cell: (cellProps) => {
          return (
            <div className="text-start">
              {cellProps.row.original.projectDetails?.project_name}
            </div>
          );
        },
      },

      {
        Header: "Title",
        accessor: "subject",
        isInfoIcon: false,
        isShortIcon: false,
        className: "support_title",
        Cell: (cellProps) => {
          return (
            <div className="text-start">{cellProps.row.original.subject}</div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        isInfoIcon: false,
        isShortIcon: false,
        className: "support_status",
        Cell: (cellProps) => {
          return (
            <div className="text-start">
              <select
                className="form-select me-1 mb-1 "
                value={String(cellProps?.row?.original?.status)}
                onChange={(e) =>
                  onstatusChange(cellProps?.row?.original?.id, e.target.value)
                }
              >
                {ticketStatus.map((item) => (
                  <option key={item?.value} value={item?.value}>
                    {item?.label}
                  </option>
                ))}
              </select>
            </div>
          );
        },
      },

      {
        Header: "Created At",
        accessor: "created_at",
        isInfoIcon: false,
        isShortIcon: false,
        className: "support_created",
        Cell: (cellProps) => {
          return (
            <div className="">
              {moment(cellProps.row.original.created_at).format("DD/MM/YYYY")}
            </div>
          );
        },
      },

      {
        Header: "Action",
        accessor: "action",
        className: "support_action",
        isInfoIcon: false,
        Cell: (cellProps) => {
          return (
            <>
              <div className="d-flex justify-content-center">
                <a
                  className="btn btn-sm btn-outline-secondary me-1"
                  title="Reply Ticket"
                  onClick={() => {
                    setReplyTicket(true);
                    setsupport_id(cellProps?.row?.original?.id);
                    fetchReply(cellProps?.row?.original?.id);
                  }}
                >
                  <i className="fas fa-reply"></i>
                </a>
                {/* <a
                  onClick={() => setEditTicket(true)}
                  className="btn btn-sm btn-outline-secondary me-1"
                  title="Edit Ticket"
                >
                  <i className="fas fa-pen"></i>
                </a> */}

                <UncontrolledDropdown
                  className="dropdown"
                  style={{ width: "29px" }}
                >
                  <DropdownToggle
                    className="btn btn-sm btn-outline-secondary w-100"
                    color="white"
                  >
                    <i className="mdi mdi-dots-horizontal"></i>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-end">
                    <a
                      title="Delete Ticket"
                      className="dropdown-item"
                      onClick={(e) => onDelete(e)}
                    >
                      <i className="fas fa-trash-alt text-danger pr-10 me-2"></i>{" "}
                      Delete Ticket
                    </a>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const [CurrentProject, setcurrentproject] = useState("");
  const data = useMemo(() => {

    const TodaysData1 = Data?.filter((item) =>
      TodaysData?.some((t) => t.support_id === item.id)
    );

    let sourceData = Todays === true ? TodaysData1 : Data;


    if (CurrentProject !== "") {
      sourceData = sourceData?.filter(item => item?.project_id == CurrentProject);
    }

    switch (supportType) {
      case "3":
        return sourceData.filter((item) => item.status === "0");
      case "4":
        return sourceData.filter((item) => item.status === "1");
      case "5":
        return sourceData.filter((item) => item.status === "2");
      case "6":
        return sourceData.filter((item) => item.status === "3");
      case "7":
        return sourceData.filter((item) => item.status === "4");
      case "8":
        return sourceData.filter((item) => item.status === "5");
      default:
        return defaultData; // or an empty array
    }
  }, [supportType, Data, Todays, CurrentProject]);

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Support"} />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      projects={Projects}
                      CurrentProject={CurrentProject}
                      setCurrentProject={setcurrentproject}
                      setTodays={setTodays}
                      Todays={Todays}
                      fetchSupport={fetchSupport}
                      alldata={Data}
                      columns={columns}
                      data={data}
                      setAccessDenied={setAccessDenied}
                      setFilter={setFilter}
                      filter={filter}
                      supportType={supportType}
                      setSupportType={setSupportType}
                      formPopup={formPopup}
                      setFormPopup={setFormPopup}
                      selectToMove={selectToMove}
                      setSelectToMove={setSelectToMove}
                      setNoDrag={setNoDrag}
                      noDrag={noDrag}
                      Projects={Projects}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Edit Ticket  */}
      <div className={`note-sticky-form ${editTitcket ? "d-block" : "d-none"}`}>
        <Draggable
          handle={`${noDrag ? ".modal-header" : ""}`}
          cancel={`${noDrag ? ".modal-body" : ""}`}
        >
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "16%",
              right: "16%",
              zIndex: "1055",
              backgroundColor: "#fff",
              maxHeight: "fit-content",
              transform: "translate(-50%, -50%)",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0">Edit Ticket</h5>
              <button
                type="button"
                onClick={() => {
                  setEditTicket(false);
                }}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>

            <div className="modal-body pe-4">
              <Form className="row d-flex justify-content-center align-items-center">
                <div className="col-md-12 d-flex flex-column new-task-modal mt-4">
                  <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                    <div className="col-sm-2 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Location <span className="text-danger">*</span>
                      </Label>
                      <Select
                        placeholder="Select Location"
                        className="basic-multi-select"
                        classNamePrefix=" select"
                        options={locationOptions}
                        styles={colourStyles}
                      />
                    </div>
                    <div className="col-sm-8 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Title <span className="text-danger">*</span>
                      </Label>
                      <div className="d-flex justify-content-start align-items-center gap-2">
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Enter Title"
                          onDoubleClick={() => setNoDrag(true)}
                          onMouseLeave={() => setNoDrag(false)}
                          onMouseEnter={() => setNoDrag(true)}
                        />
                      </div>
                    </div>
                    <div className="col-sm-2 ps-2">
                      <Label htmlFor="formrow-firstname-Input">Type</Label>
                      <Select
                        placeholder="Select Type"
                        className="basic-multi-select"
                        classNamePrefix=" select"
                        options={Type}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                    <div className="col-sm-4 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Select Project
                      </Label>
                      <Select
                        placeholder="Select Project"
                        className="basic-multi-select"
                        classNamePrefix=" select"
                        options={projects}
                        styles={colourStyles}
                      />
                    </div>

                    <div className="col-sm-2 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Priority <span className="text-danger">*</span>
                      </Label>
                      <Select
                        placeholder="Select Priority"
                        className="basic-multi-select"
                        classNamePrefix=" select"
                        options={priority}
                        styles={colourStyles}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end flex-column gap-4">
                    <div className="col-12 ps-2">
                      <label htmlFor="">Description</label>
                      <div
                        className="no-drag"
                        onDoubleClick={() => setNoDrag(true)}
                        onMouseLeave={() => setNoDrag(false)}
                        onMouseEnter={() => setNoDrag(true)}
                      >
                        <CKEditor
                          style={{ height: "500px" }}
                          editor={ClassicEditor}
                          onReady={(editor) => { }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-12 d-flex justify-space-between align-items-center">
                      <div className="col-md-8 ps-2 d-flex flex-column gap-2">
                        <Label htmlFor="formrow-firstname-Input mb-0">
                          Image
                        </Label>
                        <div className="d-flex text-start gap-2 flex-wrap pb-2">
                          <span
                            className="text-light badge bg-primary"
                            title="Click To Open"
                            style={{ cursor: "pointer", fontSize: "0.8rem" }}
                          >
                            Support Section Add Task
                            <i
                              className="fas fa-times text-danger ps-1"
                              title="Remove"
                            ></i>
                          </span>
                          <span
                            className="text-light badge bg-primary"
                            title="Click To Open"
                            style={{ cursor: "pointer", fontSize: "0.8rem" }}
                          >
                            Support Section Edit Task
                            <i
                              className="fas fa-times text-danger ps-1"
                              title="Remove"
                            ></i>
                          </span>
                          <span
                            className="text-light badge bg-primary"
                            title="Click To Open"
                            style={{ cursor: "pointer", fontSize: "0.8rem" }}
                          >
                            Support Section Reply Task{" "}
                            <i
                              className="fas fa-times text-danger ps-1"
                              title="Remove"
                            ></i>
                          </span>
                        </div>
                      </div>

                      <div className="my-2 text-end">
                        <button className=" btn btn-save btn-label">
                          <i className="fas fa-save me-2 label-icon"></i>
                          Submit
                        </button>
                        <a
                          onClick={() => setEditTicket(false)}
                          className=" btn ms-md-2 btn-red btn-label"
                        >
                          <i className="dripicons-cross me-2 icon-center label-icon"></i>
                          CANCEL
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* <Row className="bg-white px-2 py-2 shadow mb-3">
                      <div className="d-flex justify-content-end align-items-end px-0">
                        <div className="text-end mb-3">
                          <button
                            onClick={e => {
                              e.preventDefault()
                              onAddFormRow()
                            }}
                            className="btn btn-purple  "
                          >
                            <i className="fas fa-plus me-2"></i>
                            Add Subtask
                          </button>
                        </div>
                      </div>
                     
                    </Row> */}
                </div>
              </Form>
            </div>
          </ResizableBox>
        </Draggable>
      </div>

      {/* Reply Ticket  */}
      <Modal size="xl" isOpen={replyTicket} className="modal-fullscreen">
        <div className="modal-header mb-0">
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ width: "100%" }}
          >
            <div className="col-6 d-flex align-items-center">
              <h5 className=" modal-title mt-0">Reply Ticket</h5>
            </div>
            <div className="col-6 d-flexs text-end">
              <button
                className=" btn btn-save btn-label"
                onClick={() => onAddReply()}
              >
                <i className="fas fa-save me-2 label-icon"></i>
                Submit
              </button>
              <a
                onClick={() => setReplyTicket(false)}
                className=" btn ms-md-2 btn-red btn-label"
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                CANCEL
              </a>
            </div>
          </div>
        </div>

        <div className="modal-body hide-bottom-scrollbar ps-0 pe-0 pt-0 overflow-hidden">
          <div className="mb-3" style={{ padding: "0 11px 0 12px" }}>
            <Form className="row d-flex justify-content-center align-items-center">
              <div className="col-md-12 px-3 d-flex justify-content-between align-items-centers new-task-modal ">
                <div className="col-md-6 ps-0 pe-2 d-flex flex-column justify-content-start align-items-start flex-column">
                  <h5 className="mt-3">Chat History</h5>
                  {/* Static Notes Section */}
                  <div className=" mt-3 ticket-history-box w-100" style={{ overflowX: 'hidden' }}>
                    <ul className="verti-timeline list-unstyled notes-box    w-100">
                      {/* Message 1 */}
                      {Replys?.map((item, index) => (
                        <li
                          key={index}
                          className="event-list position-relative"
                        >
                          <div className="event-timeline-dot connected-dot">
                            <img
                              src={userImg}
                              className="msgUserImg me-3"
                              alt="User Avatar"
                            />
                          </div>
                          <div className="d-flex">
                            <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                              <div className="d-flex justify-content-start align-items-center">
                                <div>
                                  <h6 className="d-inline me-2">
                                    Ticket Replyed by {item?.type}
                                  </h6>{" "}
                                  at{" "}
                                  {moment(item?.created_at).format(
                                    "DD/MM/YYYY HH:MM:SS"
                                  )}
                                </div>
                              </div>
                              <i className="bi bi-triangle-fill note-icon"></i>
                              <div
                                className="Features col-12 my-3"
                                dangerouslySetInnerHTML={{
                                  __html: item?.reply,
                                }}
                              ></div>
                              {Array.isArray(JSON.parse(item?.files)) &&
                                JSON.parse(item?.files).length > 0 && (
                                  <p className="mb-1">
                                    Attachments:
                                    {JSON.parse(item?.files).map(
                                      (fileUrl, index) => (
                                        <a
                                          key={index}
                                          className="text-light badge bg-primary ms-2"
                                          title="Click To Open"
                                          target="_blank"
                                          rel="noreferrer"
                                          href={fileUrl}
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "0.8rem",
                                          }}
                                        >
                                          Click
                                        </a>
                                      )
                                    )}
                                  </p>
                                )}
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="col-6 overflow-hidden border-left ps-3 d-flex flex-column justify-content-start align-items-start reply_chat_history">
                  <h5 className="mt-4">Add Reply</h5>
                  <div className="col-12 ps-0 mt-3">
                    <label htmlFor="">
                      Description <span className="text-danger"> *</span>
                    </label>
                    <div
                      className="no-drag"
                      onDoubleClick={() => setNoDrag(true)}
                      onMouseLeave={() => setNoDrag(false)}
                      onMouseEnter={() => setNoDrag(true)}
                    >
                      <CKEditor
                        editor={ClassicEditor}
                        onReady={(editor) => { }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          setAnswer(data);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 d-flex">
                    <div className="col-md-6 d-flex justify-content-start align-items-center gap-3">
                      <div className="col-6 col-sm-7 mt-3">
                        <label htmlFor="">Attachment</label>
                        {/* custom file upload */}
                        <Dropzone
                          onDrop={(acceptedFiles) => {
                            handleAcceptedFiles1(acceptedFiles);
                          }}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div
                              className="dz-message needsclick p-0"
                              {...getRootProps()}
                            >
                              <input {...getInputProps()} />
                              <div
                                className="d-flex px-2 custom-file-upload align-items-center"
                                style={{ cursor: "pointer" }}
                              >
                                <div className="">
                                  <i className="display-6 text-muted bx bxs-cloud-upload" />
                                </div>
                                <h5 className="mb-0 ms-2">Upload Files</h5>
                              </div>
                            </div>
                          )}
                        </Dropzone>
                      </div>
                      {/* file display here */}
                      <div
                        className={`mt-3 dropzone-previews ${selectedFiles1.length > 0 ? "d-block" : "d-none"
                          }`}
                        id="file-previews"
                      >
                        <label className="mb-1">Uploaded Files</label>
                        <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                          <div className="p-0">
                            <Row className="align-items-center justify-content-evenly">
                              {selectedFiles1?.map((f, i) => {
                                return (
                                  <Col key={i} className="col-auto">
                                    <img
                                      data-dz-thumbnail=""
                                      height="80"
                                      className="avatar-sm rounded bg-light"
                                      alt={f.name}
                                      src={f.preview}
                                    />
                                  </Col>
                                );
                              })}
                            </Row>
                          </div>
                        </Card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </Modal>

      {/* Ticket History */}
      <div
        className={`note-sticky-form ${viewTicketHistory ? "d-block" : "d-none"
          }`}
      >
        <Draggable>
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "12%",
              left: "15%",
              zIndex: "1055",
              backgroundColor: "#fff",
              maxHeight: "fit-content",
              transform: "translate(-50%, -50%)",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0">Ticket History</h5>
              <button
                type="button"
                onClick={() => {
                  setViewTicketHistory(false);
                }}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>
            <div className="px-3 py-4 bg-white">
              {/* Static Notes Section */}
              <div className="mt-4 ticket-history-box">
                <ul className="verti-timeline list-unstyled notes-box">
                  {/* Message 1 */}
                  <li className="event-list position-relative">
                    <div className="event-timeline-dot connected-dot">
                      <img
                        src={userImg}
                        className="msgUserImg me-3"
                        alt="User Avatar"
                      />
                    </div>
                    <div className="d-flex">
                      <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                        <div className="d-flex justify-content-start align-items-center">
                          <div>
                            <h6 className="d-inline me-2">
                              Ticket Created By Janvi and assigned to Mohit
                            </h6>{" "}
                            at 01-01-2023 12:00:00
                          </div>

                          <div className="ml-30">
                            <a
                              className="btn btn-sm activity-log-btn text-info"
                              onClick={() => setTicketLogs(true)}
                            >
                              <i className="fas fa-eye"></i> View
                            </a>
                          </div>
                          {/* <div className="me-4">
                            <a
                              className="btn btn-sm edit-delete-btn text-success me-2"
                              onClick={() => setEditReplyMsg(true)}
                            >
                              <i className="fas fa-edit" title="Edit Reply"></i>
                            </a>
                            <button
                              className="btn btn-sm edit-delete-btn text-danger"
                              onClick={onDeleteReply}
                            >
                              <i
                                className="fas fa-trash-alt"
                                title="Delete Reply"
                              ></i>
                            </button>
                          </div> */}
                        </div>
                        <i className="bi bi-triangle-fill note-icon"></i>
                        <div className="Features col-12 my-3">
                          Create View Projects Task Section popups, Days
                          Remaining popup, Delete popup, View Task popup, and
                          changes in Edit and add Project design.
                        </div>
                        <p className="mb-1">
                          Attachment:
                          {/* <a
                            className="btn btn-sm edit-delete-btn text-secondary ml-10"
                            href="path/to/file1"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fas fa-eye"></i> View
                          </a> */}
                          <a
                            className="text-light badge bg-primary ms-2"
                            title="Click To Open"
                            target="_blank"
                            rel="noreferrer"
                            href={SampleImg}
                            style={{ cursor: "pointer", fontSize: "0.8rem" }}
                          >
                            Click here
                          </a>
                          <a
                            className="text-light badge bg-primary ms-2"
                            title="Click To Open"
                            target="_blank"
                            rel="noreferrer"
                            href={SampleImg}
                            style={{ cursor: "pointer", fontSize: "0.8rem" }}
                          >
                            Click here
                          </a>
                        </p>
                      </div>
                    </div>
                  </li>

                  {/* Message 2 */}
                  <li className="event-list position-relative">
                    <div className="event-timeline-dot connected-dot">
                      <img
                        src={userImg}
                        className="msgUserImg me-3"
                        alt="User Avatar"
                      />
                    </div>
                    <div className="d-flex">
                      <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                        <div className="d-flex justify-content-start align-items-center">
                          <div>
                            <h6 className="d-inline me-2">
                              Mohit Replied to Ticket
                            </h6>{" "}
                            at 02-01-2023 15:30:00
                          </div>

                          <div className="ml-30">
                            <a
                              className="btn btn-sm activity-log-btn text-info"
                              onClick={() => setTicketLogs(true)}
                            >
                              <i className="fas fa-eye"></i> View
                            </a>
                          </div>
                          {/* <div className="me-4">
                            <a
                              className="btn btn-sm edit-delete-btn text-success me-2"
                              onClick={() => setEditReplyMsg(true)}
                            >
                              <i className="fas fa-edit" title="Edit Reply"></i>
                            </a>
                            <button
                              className="btn btn-sm edit-delete-btn text-danger"
                              onClick={onDeleteReply}
                            >
                              <i
                                className="fas fa-trash-alt"
                                title="Delete Reply"
                              ></i>
                            </button>
                          </div> */}
                        </div>
                        <i className="bi bi-triangle-fill note-icon"></i>
                        <div className="Features col-12 my-3">
                          Updated the project dashboard UI and fixed issues with
                          the user management module.
                        </div>
                        <p className="mb-1">
                          Attachment:
                          {/* <a
                            className="btn btn-sm edit-delete-btn text-secondary ml-10"
                            href="path/to/file2"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fas fa-eye"></i> View
                          </a> */}
                          <a
                            className="text-light badge bg-primary ms-2"
                            title="Click To Open"
                            target="_blank"
                            rel="noreferrer"
                            href={SampleImg}
                            style={{ cursor: "pointer", fontSize: "0.8rem" }}
                          >
                            Click here
                          </a>
                          <a
                            className="text-light badge bg-primary ms-2"
                            title="Click To Open"
                            target="_blank"
                            rel="noreferrer"
                            href={SampleImg}
                            style={{ cursor: "pointer", fontSize: "0.8rem" }}
                          >
                            Click here
                          </a>
                        </p>
                      </div>
                    </div>
                  </li>

                  {/* Message 3 */}
                  <li className="event-list position-relative">
                    <div className="event-timeline-dot connected-dot">
                      <img
                        src={userImg}
                        className="msgUserImg me-3"
                        alt="User Avatar"
                      />
                    </div>
                    <div className="d-flex">
                      <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                        <div className="d-flex justify-content-start align-items-center">
                          <div>
                            <h6 className="d-inline me-2">
                              Janvi Repplied to Mohit
                            </h6>{" "}
                            at 03-01-2023 10:45:00
                          </div>

                          <div className="ml-30">
                            <a
                              className="btn btn-sm activity-log-btn text-info"
                              onClick={() => setTicketLogs(true)}
                            >
                              <i className="fas fa-eye"></i> View
                            </a>
                          </div>
                          {/* <div className="me-4">
                            <a
                              className="btn btn-sm edit-delete-btn text-success me-2"
                              onClick={() => setEditReplyMsg(true)}
                            >
                              <i className="fas fa-edit" title="Edit Reply"></i>
                            </a>
                            <button
                              className="btn btn-sm edit-delete-btn text-danger"
                              onClick={onDeleteReply}
                            >
                              <i
                                className="fas fa-trash-alt"
                                title="Delete Reply"
                              ></i>
                            </button>
                          </div> */}
                        </div>
                        <i className="bi bi-triangle-fill note-icon"></i>
                        <div className="Features col-12 my-3">
                          Implemented API integrations for task management and
                          optimized the backend performance.
                        </div>
                        <p className="mb-1">
                          Attachment:
                          {/* <a
                            className="btn btn-sm edit-delete-btn text-secondary ml-10"
                            href="path/to/file3"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fas fa-eye"></i> View
                          </a> */}
                          <a
                            className="text-light badge bg-primary ms-2"
                            title="Click To Open"
                            target="_blank"
                            rel="noreferrer"
                            href={SampleImg}
                            style={{ cursor: "pointer", fontSize: "0.8rem" }}
                          >
                            Click here
                          </a>
                          <a
                            className="text-light badge bg-primary ms-2"
                            title="Click To Open"
                            target="_blank"
                            rel="noreferrer"
                            href={SampleImg}
                            style={{ cursor: "pointer", fontSize: "0.8rem" }}
                          >
                            Click here
                          </a>
                        </p>
                      </div>
                    </div>
                  </li>

                  {/* Message 4 */}
                  <li className="event-list position-relative">
                    <div className="event-timeline-dot connected-dot">
                      <img
                        src={userImg}
                        className="msgUserImg me-3"
                        alt="User Avatar"
                      />
                    </div>
                    <div className="d-flex">
                      <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                        <div className="d-flex justify-content-start align-items-center">
                          <div>
                            <h6 className="d-inline me-2">
                              Mohit Replied To Janvi
                            </h6>{" "}
                            at 03-01-2023 10:45:00
                          </div>
                          {/* <div className="me-4">
                            <a
                              className="btn btn-sm edit-delete-btn text-success me-2"
                              onClick={() => setEditReplyMsg(true)}
                            >
                              <i className="fas fa-edit" title="Edit Reply"></i>
                            </a>
                            <button
                              className="btn btn-sm edit-delete-btn text-danger"
                              onClick={onDeleteReply}
                            >
                              <i
                                className="fas fa-trash-alt"
                                title="Delete Reply"
                              ></i>
                            </button>
                          </div> */}
                          <div className="ml-30">
                            <a
                              className="btn btn-sm activity-log-btn text-info"
                              onClick={() => setTicketLogs(true)}
                            >
                              <i className="fas fa-eye"></i> View
                            </a>
                          </div>
                        </div>
                        <i className="bi bi-triangle-fill note-icon"></i>
                        <div className="Features col-12 my-3">
                          Implemented API integrations for task management and
                          optimized the backend performance.
                        </div>
                        <p className="mb-1">
                          Attachment:
                          {/* <a
                            className="btn btn-sm edit-delete-btn text-secondary ml-10"
                            href="path/to/file3"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fas fa-eye"></i> View
                          </a> */}
                          <a
                            className="text-light badge bg-primary ms-2"
                            title="Click To Open"
                            target="_blank"
                            rel="noreferrer"
                            href={SampleImg}
                            style={{ cursor: "pointer", fontSize: "0.8rem" }}
                          >
                            Click here
                          </a>
                          <a
                            className="text-light badge bg-primary ms-2"
                            title="Click To Open"
                            target="_blank"
                            rel="noreferrer"
                            href={SampleImg}
                            style={{ cursor: "pointer", fontSize: "0.8rem" }}
                          >
                            Click here
                          </a>
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </ResizableBox>
        </Draggable>
      </div>

      {/* Ticket Logs */}
      <div className={`note-sticky-form ${ticketLogs ? "d-block" : "d-none"}`}>
        <Draggable>
          <ResizableBox
            width={900}
            style={{
              position: "fixed",
              top: "25%",
              right: "21%",
              zIndex: "1055",
              backgroundColor: "#fff",
            }}
          >
            <div className="modal-content" role="document">
              <div className="support-logsmodal-header">
                <h5 className="modal-title mt-0">Log Details</h5>
                <button
                  type="button"
                  onClick={() => {
                    setTicketLogs(false);
                  }}
                  className="btn-modal-close"
                >
                  <span aria-hidden="true" className="btn-modal-span">
                    &times;
                  </span>
                </button>
              </div>
              <div className="support-logsmodal-body">
                <div className="table-responsive">
                  <table className="table mb-0 table">
                    <thead className="table-light">
                      <tr>
                        <th>Fields</th>
                        <th>Old Data</th>
                        <th>New Data</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row">Assign</th>
                        <td>
                          <div>Rahul</div>
                        </td>
                        <td>
                          <div>Mohit</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ResizableBox>
        </Draggable>
      </div>

      {/* <Modal size="md" centered isOpen={viewData} className="activity-log">
        <div className="modal-header">
          <h5 className="modal-title mt-0">Log Details</h5>
          <button
            type="button"
            onClick={() => {
              setViewData(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times
            </span>
          </button>
        </div>
        <div className="modal-body">
          <div className="table-responsive">
            <table className="table mb-0 table">
              <thead className="table-light">
                <tr>
                  <th>Fields</th>
                  <th>Old Data</th>
                  <th>New Data</th>
                </tr>
              </thead>
              <tbody>          
                    <tr >
                      <th scope="row">assignee</th>
                      <td>
                        <div>
                          Rahul
                        </div>
                      </td>
                      <td>
                        <div>
                          Mohit
                        </div>
                      </td>
                    </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Modal> */}
    </React.Fragment>
  );
};

export default SupportPage;
